"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "h-44 bg-gradient-to-b from-transparent to-beige-200 absolute bottom-0 left-0 w-full"
};
const _hoisted_2 = {
    key: 0,
    class: "text-center p-10"
};
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "View All", -1);
const vue_3 = require("vue");
const ButtonIcon_vue_1 = __importDefault(require("./ButtonIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Revealer',
    props: {
        height: {
            type: String,
            default: 'max-h-screen-80',
            required: false,
        },
        count: {
            type: Number,
            default: 3
        }
    },
    setup(__props) {
        const props = __props;
        (0, vue_3.onMounted)(() => {
            windowHeight.value = window.innerWidth;
            window.addEventListener('resize', () => {
                windowHeight.value = window.innerWidth;
            });
        });
        function show() {
            if (windowHeight.value <= 639 || (windowHeight.value <= 767 && props.count > 2) || props.count > 3) {
                return true;
            }
            return false;
        }
        const opened = (0, vue_3.ref)(false);
        const windowHeight = (0, vue_3.ref)(0);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)([opened.value ? '' : [props.height, 'overflow-y-hidden'], "relative"])
                }, [
                    (0, vue_2.renderSlot)(_ctx.$slots, "default"),
                    (!opened.value && show())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 2),
                (!opened.value && show())
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(($event) => (opened.value = true), ["prevent"])),
                            class: "button button-outlined button-mutedpurple-800 hover:button-muted-purple-600 has-icon"
                        }, [
                            (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                            _hoisted_3
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
